import { ChatMessageBase } from './chat-message-base';
import { DynamicQueryEvent } from 'common/dynamicquery/dynamic-query-events.factory';

/**
 * ChatMessages model
 * @param chat
 *  <fields>
 <field name="ChatMessageID"              type="long" generateIfNull="true"/>
 <field name="PersonType"                 type="byte" />
 <field name="PersonID"                   type="long"/>
 <field name="CannedMessageID"            type="long"/>
 <field name="Name"                       type="text" size="30"/>
 <field name="Text"                       type="text"/>
 <field name="ChatID"                     type="long"/>
 <field name="AccountID"                  type="long" useAccountIDIfNull="true"/>
 <field name="Created"                    type="created" allowsUpdates="false"/>
 <field name="Deleted"                    type="datetime"/>
 <field name="SystemMessage"              type="text"/>
 <field name="MessageKey"                 type="text"/>
 <field name="LanguageCode"               type="text"/>
 <field name="Hidden"                      type="byte" min="0" max="1"/>
 <field name="OriginalMessageID"          type="long"/>
 <field name="VisitorFacing"              type="byte"/>
 <field name="HasAutoTranslationError"    type="byte" min="0" max="1"/>
 </fields>
 *
 * @constructor
 */

export class ChatMessage extends ChatMessageBase {
  PersonID?: string;
  Name?: string;
  Text?: string;

  static comparator(message1, message2) {
    return message1.ChatMessageID === message2.ChatMessageID;
  }

  static wrap(event: Partial<DynamicQueryEvent>): ChatMessage {
    return super.wrap(event);
  }
}

export function factory() { return ChatMessage; }
